import { useGlobalClassname } from "./use-global-classname";

export const HEADER_HIDDEN_CSS_CLASSNAME = "header-hidden";

export function useHeaderHidden(isActive: boolean) {
  return useGlobalClassname(HEADER_HIDDEN_CSS_CLASSNAME, isActive);
}
